import { render, staticRenderFns } from "./ReceptionCreateCard.vue?vue&type=template&id=374dd145&scoped=true"
import script from "./ReceptionCreateCard.vue?vue&type=script&lang=js"
export * from "./ReceptionCreateCard.vue?vue&type=script&lang=js"
import style0 from "./ReceptionCreateCard.vue?vue&type=style&index=0&id=374dd145&prod&lang=scss&scoped=true"
import style1 from "./ReceptionCreateCard.vue?vue&type=style&index=1&id=374dd145&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374dd145",
  null
  
)

export default component.exports